import { MatchingRecord } from '@eluve/utils';

import { AppointmentModeTypesEnum } from './types';

export const AppointmentModeTypesLookup = {
  AUDIO_COPILOT: 'AUDIO_COPILOT',
  MANUAL_CHARTING: 'MANUAL_CHARTING',
} as const satisfies MatchingRecord<AppointmentModeTypesEnum>;
